import loadable from "@loadable/component";
import { fetchReviews } from "../features/reviews/reviewsSlice";

const TheWallOfLove = loadable(() => import("./TheWallOfLove.page"));

const loadData = (store) => {
  const actions = [fetchReviews()];
  return Promise.all(actions.map((action) => store.dispatch(action)));
};

export default { component: TheWallOfLove, loadData };
